import { FieldError } from 'react-hook-form';

export interface LeafError {
  path: (string | number)[];
  error: FieldError;
}

export function isLeafFieldError(obj: any): obj is FieldError {
  return (
    obj != null && typeof obj === 'object' && 'message' in obj && 'type' in obj
  );
}
